/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var trustGreen = '#1f8a4c';

  function findProductRoot(element) {
    if (!element) return null;
    var section = element.closest('[data-section-type="product"]');
    if (section) return section;

    var product = element.closest('[data-product]');
    return product ? product.closest('[data-section-type="product"]') || product : null;
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getProductData(root) {
    var json = root && root.querySelector('[data-product-json]');
    if (!json || !json.textContent) return null;

    try {
      return JSON.parse(json.textContent);
    } catch (error) {
      return null;
    }
  }

  function selectedOptions(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('[data-single-option-selector]:checked')).map(function(input) {
      return input.value;
    });
  }

  function findVariant(product, options) {
    if (!product || !product.variants || !options.length) return null;

    return product.variants.find(function(variant) {
      return options.every(function(option, index) {
        return variant.options && variant.options[index] === option;
      });
    });
  }

  function findSlideForVariant(root, variant, options) {
    if (!root) return null;

    if (variant && variant.featured_media) {
      var mediaId = variant.featured_media.id;
      var variantSlide = root.querySelector('[data-image-id="' + mediaId + '"]');
      if (variantSlide) return variantSlide;
    }

    var optionHandles = (options || []).map(handleize).filter(Boolean);
    for (var i = 0; i < optionHandles.length; i += 1) {
      var handle = optionHandles[i];
      var variantImage = root.querySelector('[data-variant*="variant--' + handle + '"], [data-variant*="' + handle + '"]');
      if (variantImage && variantImage.closest('.product__slide')) {
        return variantImage.closest('.product__slide');
      }
    }

    return null;
  }

  function selectVariantMedia(root, variant, options) {
    var slide = findSlideForVariant(root, variant, options);
    if (!slide) return;

    var productImages = root.querySelector('product-images');
    var mediaList = root.querySelector('[data-product-media-list]');
    var thumbLinks = root.querySelectorAll('[data-thumb-link]');
    var activeMediaId = slide.getAttribute('data-media-id');

    root.querySelectorAll('.product__slide').forEach(function(item) {
      var isActive = item === slide;
      item.classList.toggle('media--active', isActive);
      item.classList.toggle('media--hidden', !isActive);
    });

    thumbLinks.forEach(function(link) {
      var isActive = link.getAttribute('data-media-id') === activeMediaId;
      link.setAttribute('aria-current', isActive ? 'true' : 'false');
      if (link.closest('[data-thumb-item]')) {
        link.closest('[data-thumb-item]').classList.toggle('is-active', isActive);
      }
    });

    if (productImages && activeMediaId) {
      productImages.setAttribute('data-active-media', activeMediaId);
    }

    if (mediaList && typeof mediaList.scrollTo === 'function') {
      mediaList.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    slide.dispatchEvent(new CustomEvent('theme:media:select', {
      bubbles: true,
      detail: { id: activeMediaId }
    }));
  }

  function updateVariantMediaFromInput(input) {
    var root = findProductRoot(input);
    var product = getProductData(root);
    var options = selectedOptions(root);
    var variant = findVariant(product, options);
    selectVariantMedia(root, variant, options);
  }

  document.addEventListener('change', function(event) {
    if (event.target && event.target.matches('[data-single-option-selector]')) {
      window.setTimeout(function() {
        updateVariantMediaFromInput(event.target);
      }, 50);
    }
  });

  document.addEventListener('click', function(event) {
    var label = event.target && event.target.closest('label[for]');
    if (!label) return;

    var input = document.getElementById(label.getAttribute('for'));
    if (input && input.matches('[data-single-option-selector]')) {
      window.setTimeout(function() {
        updateVariantMediaFromInput(input);
      }, 100);
    }
  });

  document.addEventListener('theme:variant:change', function(event) {
    var root = findProductRoot(event.target);
    selectVariantMedia(root, event.detail && event.detail.variant, selectedOptions(root));
  });

  function makeReviewStarsGreen() {
    document.querySelectorAll('.hr-summary-bar svg polygon, .hr-review-stars svg polygon, .hr-review-star polygon').forEach(function(star) {
      if (star.getAttribute('fill') !== '#ddd') {
        star.setAttribute('fill', trustGreen);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', makeReviewStarsGreen);
  } else {
    makeReviewStarsGreen();
  }




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
